import {
  BoxDropFile,
  Button,
  CardDownloadFile,
  Creatable,
  Input,
} from '@iveco-ti/iveco-ds'
import { useFormContext } from '@iveco-ti/iveco-ds/hook-form'
import { FileUp, Trash } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useDownloadNewsAttachment } from '../hooks/useDownloadNewsAttachment'
import { useEditNewsStore } from '../stores/useEditNewsStore'

export function FormEditNewsSummary() {
  const { t } = useTranslation('panel')
  const { news } = useEditNewsStore()
  const { handleDownloadNewsAttachment } = useDownloadNewsAttachment()
  const hookForm = useFormContext()

  const NEW_FILE = hookForm.watch('postFile')

  return (
    <div className="space-y-6 pb-4">
      <h2 className="text-2xl text-sky-700 font-semibold">
        {t('news.drawer_create_news.summary.title')}
      </h2>

      <Input.Base
        name="title"
        label={t('news.drawer_create_news.fields.title.label')}
        placeholder={t('news.drawer_create_news.fields.title.placeholder')}
      />

      <Input.Base
        name="subtitle"
        label={t('news.drawer_create_news.fields.subtitle.label')}
        placeholder={t('news.drawer_create_news.fields.subtitle.placeholder')}
      />

      <Creatable.Sync
        name="tag"
        isMulti
        label={t('news.drawer_create_news.fields.tag.label')}
        placeholder={t('news.drawer_create_news.fields.tag.placeholder')}
      />

      <h3 className="text-2xl text-sky-700 font-semibold">
        {t('news.drawer_create_news.summary.subtitle')}
      </h3>

      <Input.AddOn
        name="postExternalUrl"
        leadingAddOn="https://"
        label={t('news.drawer_create_news.fields.postExternalUrl.label')}
        placeholder={t(
          'news.drawer_create_news.fields.postExternalUrl.placeholder',
        )}
      />

      <BoxDropFile.Root>
        <BoxDropFile.Label>
          {t('news.drawer_create_news.fields.postFile.label')}
        </BoxDropFile.Label>

        <BoxDropFile.Input
          name="postFile"
          title={t('news.drawer_create_news.fields.postFile.title')}
          multiple={false}
        >
          <BoxDropFile.Icon icon={<FileUp />} />
        </BoxDropFile.Input>
      </BoxDropFile.Root>

      {news?.postFile?.content &&
        (!NEW_FILE || NEW_FILE?.length === 0) &&
        NEW_FILE !== null && (
          <div className="flex items-center justify-between gap-4 w-full">
            <div className="w-full">
              <CardDownloadFile.Card
                fileName={news.postFile.content}
                fileSize={news.postFile.fileSize}
                onDownload={() =>
                  handleDownloadNewsAttachment({
                    newsId: news.id,
                    fileName: news?.postFile?.content,
                  })
                }
              />
            </div>

            <Button.Root
              variant="secondary"
              color="danger"
              className="shrink-0"
              size="lg"
              onClick={() => hookForm.setValue('postFile', null)}
            >
              <Trash />
              {t('news.drawer_edit_news.fields.postFile.button_remove')}
            </Button.Root>
          </div>
        )}
    </div>
  )
}
